export default "__VITE_ASSET__BZyT0M5n__"